export function formatTeamNameForUrl({
    name,
    seasonName,
    seasonYear,
}: {
    name: string;
    seasonYear: number;
    seasonName: string;
}) {
    return encodeURIComponent(
        `${seasonYear}-${seasonName.trim()}-${name.trim()}`
            .replace(/[\t]+/g, '-')
            .replace(/[^a-zA-Z0-9-]+/g, '-')
            .replace(/[-]+$/, '')
            .toLocaleLowerCase(),
    );
}
